import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { PERMISSION_HO_TEAM_ID } from 'src/app/handover-constants';
import { Handover } from 'src/app/interfaces/handover';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-home-content-sent-rejected',
  templateUrl: './home-content-sent-rejected.component.html',
  styleUrls: ['./home-content-sent-rejected.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HomeContentSentRejectedComponent implements OnInit {
  @Input() handoversRejectedPersonal: Handover[] | undefined;
  @Input() totalHandoversRejectedPersonal: number | undefined;
  @Input() searchRejectedPersonal: string | undefined;
  @Output() reloadRejected = new EventEmitter<boolean>();
  @Output() eventShowRejectedPersonal = new EventEmitter<boolean>();
  @Output() handoversRejectedPersonalWithFilter = new EventEmitter<string>();

  canPermissionTeam = false;
  destinationLabel = 'Hacia';
  textSearch = '';

  constructor(private userService: UserService) {
    // Agrego esta linea para que Husky deje hacer commit y push.
  }

  ngOnInit(): void {
    this.canPermissionTeam = this.userService.hasPermission(
      PERMISSION_HO_TEAM_ID
    );
    this.textSearch = this.searchRejectedPersonal
      ? this.searchRejectedPersonal
      : '';
  }

  eventReload(reload: boolean) {
    this.reloadRejected.emit(true);
  }
  showRejectedTeam() {
    this.eventShowRejectedPersonal.emit(false);
  }

  getHandoversHomeRejectedPersonalWithFilter(searchText: string): void {
    this.textSearch = searchText;
    this.handoversRejectedPersonalWithFilter.emit(searchText);
  }
}
